import React from 'react';
import { createRoot } from 'react-dom/client';
import { store } from './app/store';
import { Provider } from 'react-redux';
import { getCookiebotId } from './components/UtilsForCookiebot';


const cookiebotId = getCookiebotId();

if (cookiebotId && !document.getElementById('Cookiebot')) {
  const script = document.createElement('script');
  script.id = 'Cookiebot';
  script.src = 'https://consent.cookiebot.com/uc.js';
  script.setAttribute('data-cbid', cookiebotId);
  script.setAttribute('data-blockingmode', 'auto');
  script.setAttribute('data-callback', 'CookiebotCallback_OnAccept');
  script.type = 'text/javascript';
  document.head.appendChild(script);
}

const MATOMO_URL = process.env.REACT_APP_MATOMO_URL;
const MATOMO_SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID;

// Cookiebot callback when the user accepts cookies
window.CookiebotCallback_OnAccept = function () {
  if (window.Cookiebot?.consent?.statistics) {
    enableStatisticsCookies();
  }
};

function enableStatisticsCookies() {
  
  // Vérifier si Matomo existe pour cette app
  if (!MATOMO_URL || !MATOMO_SITE_ID) {
    return;
  }

  window._paq = window._paq || [];

  window._paq.push(['setTrackerUrl', MATOMO_URL + 'matomo.php']);
  window._paq.push(['setSiteId', MATOMO_SITE_ID]);
  window._paq.push(['trackPageView']);
  window._paq.push(['enableLinkTracking']);

  // Charger Matomo si pas encore chargé
  if (!document.getElementById('matomo-script')) {
    const script = document.createElement('script');
    const s = document.getElementsByTagName('script')[0];

    script.id = 'matomo-script';
    script.src = MATOMO_URL + 'matomo.js';
    script.type = "text/javascript";    
    script.async = true;
    s.parentNode?.insertBefore(script, s);
  }
}



const container = document.getElementById('root')!;
const containerHeader = document.getElementById('header')!;
const containerSidebar = document.getElementById('sidebar')!;
const containerFooter = document.getElementById('footer')!;
const containerLogin = document.getElementById('rootLogin')!;

const root = createRoot(container);
const header = createRoot(containerHeader);
const sidebar = createRoot(containerSidebar);
const footer = createRoot(containerFooter);
const login = createRoot(containerLogin);

function renderRoot() {
  const App = require('./app/App').default;
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>
    );
}


function renderHeader() {
  const AppHeader = require('./app/AppHeader').default;
  header.render(
      <React.StrictMode>
        <Provider store={store}>
          <AppHeader/>
        </Provider>
      </React.StrictMode>,
    );
}

function renderSidebar() {
  const AppSidebar = require('./app/AppSidebar').default;
  sidebar.render(
      <React.StrictMode>
        <Provider store={store}>
          <AppSidebar/>
        </Provider>
      </React.StrictMode>,
    );
}

function renderFooter() {
  const AppFooter = require('./app/AppFooter').default;
  footer.render(
      <React.StrictMode>
        <Provider store={store}>
          <AppFooter/>
        </Provider>
      </React.StrictMode>,
    );
}

function renderLogin() {
  const AppLogin = require('./app/AppLogin').default;
  login.render(
      <React.StrictMode>
        <Provider store={store}>
          <AppLogin/>
        </Provider>
      </React.StrictMode>,
    );
}

renderRoot();
renderHeader();
renderSidebar();
renderFooter();
renderLogin();